module.exports = __webpack_public_path__ + "static/media/helm-vision-group.14939c9f.png";